import { WaitingPrice } from 'components/shared/Price/WaitingPrice';
import { CancelButton, PriceNext, QuoteStatus, Spinner } from 'components/shared/PriceNext';
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar';
import { useProgressTimer } from 'hooks/useProgressTimer';
import { FC, PropsWithChildren, useCallback, useContext } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

import { SolveModeLabel } from '../SolveMode';
import type { QuotingState } from './Quoting.connect';
import { connectQuoting } from './Quoting.connect';

export const Component: FC<PropsWithChildren<QuotingState>> = ({
  workspaceType,
  quoteRequestStartingTimeInMillis,
  estimatedQuotingDurationInMillis = quoteRequestStartingTimeInMillis,
  solvingMode,
  isTradable,
  isQuoteAcked,
  children,
  onQuoteCancelled,
}) => {
  const { progressInPercent } = useProgressTimer(quoteRequestStartingTimeInMillis, estimatedQuotingDurationInMillis);
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);

  const onCancel = useCallback(() => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Cancel quote (From status)');
    onQuoteCancelled();
  }, [onQuoteCancelled, logAnalyticsCategory]);

  if (workspaceType === 'static' || workspaceType === 'dynamic') {
    return (
      <PriceNext
        className="text-secondary border"
        solveMode={
          <SolveModeLabel workspaceType={workspaceType} solvingMode={solvingMode} isMultipleSolvingMode={false} />
        }
        blinker={<div className="blinker blinker-sm"></div>}
        countDownBar={<ProgressBar className="bg-secondary" percent={100 - progressInPercent} />}
        quoteStatus={
          <QuoteStatus
            className="text-secondary"
            icon={Spinner}
            description="sidePanel.quoteStatus.inProgress"
            action={isQuoteAcked ? <CancelButton onCancel={onCancel} /> : undefined}
          />
        }
      />
    );
  }

  return (
    <WaitingPrice
      color={isTradable ? 'info' : 'success'}
      onCancel={isQuoteAcked ? onCancel : undefined}
      progressInPercent={progressInPercent}
      topRightActions={children}
    />
  );
};

export const QuotingComponent = connectQuoting(Component);
